import { LayoutConst } from "core";

export const EMBLEM_MOBILE_SIZE = { width: `${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}`, height: 236 };
export const EMBLEM_TABLET_TABLET_SIZE = { width: 166, height: 236, gap: 16 };
export const EMBLEM_LAPTOP_TABLET_SIZE = { width: 204, height: 290, gap: 24 };
export const EMBLEM_DESKTOP_SIZE = { width: 270, height: 382, gap: 24 };import { LayoutConst } from "core";

export const EMBLEM_MOBILE_SIZE = { width: `${(LayoutConst.projectCard.xs.w * 2) + LayoutConst.projectCardGap.tablet}`, height: 236 };
export const EMBLEM_TABLET_TABLET_SIZE = { width: 166, height: 236, gap: 16 };
export const EMBLEM_LAPTOP_TABLET_SIZE = { width: 204, height: 290, gap: 24 };
export const EMBLEM_DESKTOP_SIZE = { width: 270, height: 382, gap: 24 };